import { 
  EuiFlexGroup,
  EuiFlexItem,
  EuiIcon,
  EuiPage,
  EuiPageBody,
  EuiPageContent,
  EuiPageContentBody,
  EuiPageContentHeader,
  EuiPageContentHeaderSection,
  EuiSpacer,
  EuiStat,
  EuiTitle,} from '@elastic/eui';
import React from 'react';
import { LoginScreen } from './Screen/screen';
import reactSvg from "../../../../ui/src/components/GlobalNavigation/L_ROYT.png";
import { version } from "../../../../../package.json";
import "./styles.css";

export const LoginView = () =>{
  return (
    <EuiPage className="pageLogin">
    <EuiPageBody component="div">
      <EuiPageContent verticalPosition="center" horizontalPosition="center">
        <EuiPageContentHeader>
          <EuiPageContentHeaderSection>
          <EuiFlexGroup>
            <EuiFlexItem grow={false}><EuiIcon type={reactSvg} title="Objetivos y Tendencias" className="logoLogin"/></EuiFlexItem>
            <EuiFlexItem>
              <EuiTitle textTransform="uppercase">
              <h2>Objetivos y Tendencias</h2>
              </EuiTitle>
            </EuiFlexItem>
          </EuiFlexGroup>
          </EuiPageContentHeaderSection>
        </EuiPageContentHeader>
        <EuiPageContentBody >
          <LoginScreen />
        </EuiPageContentBody>
        <EuiSpacer size="m"/>
        <EuiStat title={`Versión ${version}`} description={``} titleSize="xxs" titleColor="#006BB4" textAlign="right" titleElement="i"/>
      </EuiPageContent>
    </EuiPageBody>
  </EuiPage>
  )
}
export default LoginView;